export default __webpack_public_path__ + "static/media/error.634db407.svg";